module.exports = __webpack_public_path__ + "img/weather_old.be5bf8f4.svg";